module.exports = __webpack_public_path__ + "img/logo2.b587b186.png";